import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface PodScribeScriptProps {
  advertiserId?: string;
  userId?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function podScribe(ctx: PodScribeScriptProps) {
  /* eslint-disable */
  if (ctx.advertiserId && ctx.userId) {
    // prettier-ignore
    (function (w, d) {
      var e,s;
      var id = 'podscribe-capture',
      n = 'script';
      e = d.createElement(n);
      e.id = id;
      e.src = 'https://d34r8q7sht0t9k.cloudfront.net/tag.js';
      s = d.getElementsByTagName(n)[0];
      s.parentNode.insertBefore(e, s);
      e.addEventListener('load', function() {
        w['podscribe']('init', { user_id: ctx.userId, advertiser: ctx.advertiserId });
        // Dispatch custom event after initialization
        const event = new CustomEvent('PodScribeReady');
        w.dispatchEvent(event);
      })
    })(window, document);
  }
  /* eslint-enable */
}

export const PodScribeScript = (props: PodScribeScriptProps): JSX.Element => {
  const advertiserId = props.advertiserId || process.env.NEXT_PUBLIC_PODSCRIBE_ADVERTISER_ID;
  const userId = props.userId || process.env.NEXT_PUBLIC_PODSCRIBE_USER_ID;

  return (
    <Head>
      {advertiserId && userId && preConnect('https://d34r8q7sht0t9k.cloudfront.net')}
      {advertiserId && userId && makeScript(podScribe, { advertiserId, userId })}
    </Head>
  );
};

export const registerPodScribeReady = (handler: () => void) => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('PodScribeReady', handler);
    window.addEventListener('PodScribeReady', handler);
  }
};

export default PodScribeScript;
